import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { fetchSingleVideo } from '../utils/api'

import SingleVideo from '../components/SingleVideo/SingleVideo'

function Video () {
  const { videoID } = useParams()
  const [data, setData] = useState({})

  useEffect(() => {
    fetchSingleVideo(videoID).then(video => setData(video))
  }, [videoID])


  return <>
    {data?.id ? (
      <SingleVideo {...data}/>
    ) : (
      <div style={{
        minHeight: '80vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
        <p style={{ fontSize: '1.5rem' }}>
          {data.message
            ? (
              <>
                An internal server error occurred while loading the video.
                <br/>
                Try to reload this page to fix the issue.
              </>
            )
            : 'Loading...'
          }
        </p>
      </div>
    )}
  </>
}

export default Video